export const DETAIL_TABLE_TYPE = {
  sctm_compl_rpt: { name: "SCTM Compliance Report", key: "sctmComplianceReport" },
  test_guid_rpt: { name: "Test and Evaluation (T&E) Report", key: "testGuidanceReport" },
} as const;
